<template>
    <div class="page" style="overflow: auto">
        <div class="page-content" style="padding: 0">
            <div id="copycontent" class="type8">
                <section class="content" style="margin: 0 0.4rem">
                    <p class="innerTitle"><span>你要是敢躲，就不止這些了</span></p>
                    <section class="boxb">
                        <p>
                            將夜會所門口，寧也在跟好友陳芮打電話，遠遠看到一行人正簇擁著一個男人跨步往門口走來。
                        </p>
                        <p>
                            寧也想避開卻己經來不及，猶豫了一下，站著沒動，等男人走近了，才有些生硬的叫了他一聲：“小叔。”
                        </p>
                        <p>
                            傅蘊庭腳步頓住，目光落在她身上，深暗無波。
                        </p>
                        <p>
                            他認出來了，這是他那個沒有血緣的哥哥的女兒
                        </p>
                        <p>
                            寧也垂著頭，能感覺到他的視线落在自己身上，像是帶著重量。 </p>
                        <p>
                            沉默的時間有些長，傅蘊庭投注過來的目光猶如泰山壓頂。
                        </p>
                        <p>
                            “和同學約好的。
                        </p>
                        <p>
                            “經常來將夜？”
                        </p>
                        <p>
                            “沒有，同學過生日，推不掉，才過來的這邊。”
                        </p>
                        <p>
                            “嗯。”傅蘊庭鼻腔微哼，定定看了她一眼：“聚會什麼時候結束？”
                        </p>
                        <p>
                            寧也斟酌道：“應該不會很晚。”
                        </p>
                        <p>
                            “要不要一起上去。”
                        </p>
                        <p>
                            寧也說：“不用，我朋友馬上就過來了。”
                        </p>
                        <p>
                            傅蘊庭遞給了她一張卡：“有事找我。”
                        </p>
                        <p>
                            寧也頓了一下，將卡接了過來：“謝謝小叔。”
                        </p>
                        <p>
                            寧也用力捏著手上的卡，目光在卡上停留了片刻，把卡丟在了一旁的垃圾桶。
                        </p>
                        <p>
                            ......
                        </p>
                        <p>
                            寧也是上個星期在將夜工作的時候遇到的蕭梁他們，當時蕭梁將寧也摁在沙發上，要脫寧也的衣服，寧也情急之下，朝著對方的腦袋砸了一酒瓶子。
                        </p>
                        <p>
                            她那一酒瓶子砸下去，整個房間都寂靜了。
                        </p>
                        <p>
                            要知道蕭梁可是他們這一群人裡背景最深，最讓人忌憚的人。
                        </p>
                        <p>
                            後來還是蕭梁那邊不知道誰喊了一聲：“愣著干什麼，趕緊送醫院去！”
                        </p>
                        <p>
                            房間裡的人才開始打電話的打電話，喊人的喊人。
                        </p>
                        <p>
                            那場面當時異常的混亂，寧也也是趁著大家沒怎麼反應過來的時候，慌慌張張的跑了出來。
                        </p>
                        <p>
                            但是寧也跑出來的第二天，將夜的徐哥就打了電話過來，讓她先别去將夜了，然後沒兩天，又收到了學校的勸退通知。
                        </p>
                        <p>
                            對方大概覺得她可憐，還委婉的問她，是不是得罪了什麼人。
                        </p>
                        <p>
                            等回過神來，才心慌的去將夜找人打聽蕭梁的電話。
                        </p>
                        <p>
                            電話打過去，蕭梁那邊在抽煙，他問：“誰？”
                        </p>
                        <p>
                            寧也的聲音天生有點細軟：“蕭少，您好，我是寧也，我能和您見一面嗎？”
                        </p>
                        <p>
                            蕭梁那邊輕輕的咬著煙，手中把玩著打火機，聲音相當的清冷陌生：“你說什麼？
                        </p>
                        <p>
                            我沒怎麼聽清楚。”
                        </p>
                        <p>
                            “對不起。”寧也手指緊緊的捏著手機：“我想跟您當面道歉，您什麼時候有空，我去將夜等您好不好？”
                        </p>
                        <p>
                            蕭梁那邊沉默了很久，久到寧也的心幾乎沉到底，對方才懶懶的輕嘲了一聲，開口：“就將夜二樓，208房間，你下周二晚上八點過來。”
                        </p>
                        <p>
                            那是當時寧也用酒瓶子砸他的包間。
                        </p>
                        <p>
                            ------
                        </p>
                        <p>寧也深吸一口氣，才按了裡面的門鈴。</p>
                        <p>包間的門沒怎麼關緊，門鈴聲一響，裡面就傳來一聲：“進來。”</p>
                        <p>寧也按門鈴的手抖了一下，漸漸推開包間的門。</p>
                        <p>蕭梁坐在角落，視线正好落在她身上。</p>
                        <p>他坐的位置有些暗，寧也看不太清楚他的表情，只覺得那雙眼睛格外的沉。</p>
                        <p>寧也站在房間門口沒動。</p>
                        <p>蕭梁說：“進來。”</p>
                        <p>包間裡那麼多人，可他的聲音卻擲地有聲。</p>
                        <p>寧也抿了抿唇，走了進去。</p>
                        <p>蕭梁說：“自己脫了爬過來。”</p>
                        <p>寧也僵硬著站定了，臉色發白，她說：“蕭少，上次的事情是我不對，我向你道歉，求您大人有大量，别和我計較。”</p>
                        <p>蕭梁臉上的表情冰冷如霜，顯然並不接受她的道歉。</p>
                        <p>他不說話，周圍的人都在看他的臉色，也不敢吭聲。</p>
                        <p>寧也看了一眼茶幾上的酒，自己去倒了三杯，她心裡惴惴的，把姿態放得很低，說：“我先自罰三杯，蕭少，上次是我不懂事，我要怎麼做你才肯放過我？”</p>
                        <p>蕭梁沒出聲。</p>
                        <p>旁邊不知道誰喊了一聲：“你上次砸我們蕭少那麼有種，這會兒慫了？現在給你兩個選擇，要麼爬過來，要麼你有種就把我們這兒的人全喝趴下，到時候我們自然放你走。</p>
                        <p>他們這兒一共有十來號人，而且各個是圈子裡混大的，誰是個不能喝的主兒？要把這些人都喝趴下，就是把寧也喝死，寧也也喝不贏。</p>
                        <p>寧也垂下長長的眼睫，思考了一會兒，才轉頭看向蕭梁：“蕭少，可以嗎？”</p>
                        <p>蕭梁定定看了她一眼，昏暗的燈光掩蓋了他的臉，顯得他的那雙眼睛神情難測，倒是薄唇輕掀：“可以。”</p>
                        <p>寧也笑了笑，說：“這樣喝多沒有意思，既然要向蕭少賠罪，那至少也要拿出誠意來才行，蕭少你說對嗎？”</p>
                        <p>她說著，招來了服務員，朝著服務員耳邊說了幾句什麼。</p>
                        <p>服務員朝著蕭梁看過去。蕭梁臉上沒什麼表情，打量著寧也，像是要將她看穿。</p>
                        <p>半響，道：“聽她的。”</p>
                        <p>沒多久，服務員拿了一大疊小尖椒過來，個個新鮮個大。</p>
                        <p>寧也說：“光比酒沒有什麼意思，要不我們這樣，吃一根小尖椒，喝一杯酒，如果我贏了，蕭少，我們之間的恩怨可以一筆勾銷嗎？”</p>
                        <p>蕭梁的眸色轉沉。</p>
                        <p>蕭梁定定的看著寧也。</p>
                        <p>寧也迎視著他。</p>
                        <p>良久，蕭梁說：“可以。”</p>
                        <p>寧也於是端起酒杯，聲音還是細軟的，她走向了剛剛提出意見的那個人身邊。
                            寧也上次聽人叫過他的名字，叫祁邵。</p>
                        <p>寧也道：“祁少，我們先開始喝？”</p>
                        <p>祁邵臉色變了變。</p>
                        <p>寧也沒多說什麼，先吃了一根小尖椒，然後將手裡的酒一飲而儘。</p>
                        <p>周圍響起了一片抽氣聲。</p>
                        <p>祁邵臉色由白轉青再轉紅，寧也卻始終等著他，祁邵看了一眼蕭梁，見蕭梁沒有阻止的意思，臉又開始白了，卻還是拿著小尖椒吃了一口。</p>
                        <p>小尖椒吃到嘴裡還沒下咽，就嗆咳起來，一杯酒下肚，胃就開始痙攣起來。</p>
                        <p>寧也一連輪了好幾個。</p>
                        <p>包間裡的氣氛開始變得詭異起來，有人一開始就拿了手機來拍視頻，邊拍邊放到網上去。</p>
                        <p>------</p>
                        <p>傅蘊庭在將夜會所三樓的包間裡，和一群朋友見面。 　　</p>
                        <p>突然有人驚恐的“臥槽！”了一聲。 </p>
                        <p>“快去看群，群裡都傳瘋了，這女的瘋了嗎這麼喝？這已經是她灌倒下的第五個人了。” </p>
                        <p> 一個長得很漂亮，看上去年紀卻不大的小女孩兒，正在和人拚酒，她的額頭全是細密的汗，臉色卻是不正常的慘白。</p>
                        <p>她站在一個男人面前，將小尖椒一口咬進嘴裡，然後一杯啤酒下肚，眼睛就盯著對面的男人，等著對方喝酒。 </p>
                        <p>有點逼迫的樣子。</p>
                        <p>“怎麼了？”傅蘊庭因為夾著煙，有煙味，剛剛沒湊過去看。</p>
                        <p>周韓深把手機遞給他：“你自己看看。” 　　</p>
                        <p>傅蘊庭接過手機，卻在看清楚屏幕裡女孩兒的那張臉時，臉色沉了一下。他認出來了，這是剛剛不久前，還朝著他撒謊說是參加朋友生日聚會，並且不常常來將夜的寧也。</p>
                        <p>傅蘊庭眼神沉了沉，想著剛剛在門口和寧也的對話，他沉默的抽了一口煙，然後修長有力的指尖把煙在煙灰缸裡摁滅了，拿起搭在一旁的西裝外套，站起身：“我出去一趟。” “你去哪兒？”周韓深詫異的看著他。</p>
                        <p>他說：“有點事。” 說完就出了門，邊走邊給人發信息。 </p>
                        <p>那邊很快就回了過來，信息上面附隨一個電話號碼。出了門傅蘊庭直接撥了寧也的電話。</p>
                        <p>而與此同時，將夜會所門口，寧也閉著眼睛，忍受著嘴裡和五臟六腑裡痙攣一般灼燒的痛感，半天沒有動靜。 </p>
                        <p>電話響了好幾聲，她才迷迷糊糊的反應過來是自己的，寧也摸了幾次才摸到手機，有些神誌不清的將電話接起來：“喂，您好，哪位？” 她的話剛說完，聽筒裡倏地傳來一聲低沉的聲音：“在哪裡？” 寧也猛地聽到這聲音，心臟條件反射停滯了一瞬，整個人都有些清醒過來。</p>
                        <p>寧也腦子混亂了好一會兒，才不敢確定的問道：“小叔？” </p>
                        <p>“哪個包間？” </p>
                        <p>“我還在會所給同學過生日，怎麼了？” 電話裡沉默片刻，寧也聽到了打火機的聲音，對方應該是在吸煙，片刻後，他道：“寧也，我問你在哪個包間。” </p>
                        <p>
                            寧也啞聲片刻，最後只得老老實實的道：“在將夜門口。”
                        </p>
                        <p>
                            沒等多久，身後就響起了汽車引擎的聲音，有人下了車，沉穩的腳步聲在寂靜的街道上響起來，離她這邊越來越近。
                        </p>
                        <p>
                            寧也明明背對著對方，卻從引擎聲傳過來的時候，心臟的跳動就讓她有點振聾發聵。
                        </p>
                        <p>
                            傅蘊庭站在她面前，居高臨下的看著她：“喝了多少？” 寧也說：“沒多少。” 傅蘊庭眸色深諳，他說：“我記得我有告訴過你，讓你有事找我。”
                        </p>
                        <p>
                            “我沒事。我記得的，只是沒有遇到要麻煩您的事情。”
                        </p>
                        <p>
                            傅蘊庭沒再說什麼，朝著路邊停著的車子走過去，他上了車子，發現寧也沒有跟上來，開口：“還不上車？” 寧也不敢上他的車，也抗拒上他的車：“我在等朋友過來。”
                        </p>
                        <p>
                            傅蘊庭沉了聲音：“上車。”
                        </p>
                        <p>
                            傅蘊庭車子開得很快，寧也痛得五臟六腑都像是擰成一團，但一直忍著沒吭聲。
                        </p>
                        <p>
                            沒多久，她僅剩的一點意識，也隨著五臟六腑裡劇烈的痛楚而慢慢消失，整個人陷入了一片昏暗。 　　
                        </p>
                        <p>
                            …… 　　
                        </p>
                        <p>
                            再次醒過來的時候，人已經躺在了醫院裡，入眼就是一片雪白。
                        </p>
                        <p>
                            寧也腦子懵了好一會兒，才反應過來這是醫院。
                        </p>
                        <p>
                            在看清傅蘊庭的那一刻，寧也心裡有些不自覺的緊張，她想不動聲色的收回視线。
                        </p>
                        <p>
                            然而就在這個時候，不知道是不是聽到了這邊的響動聲，傅蘊庭倏地轉過了頭，朝著寧也看了過去。
                        </p>
                        <p>四目相對，傅蘊庭的一雙眼睛沉得像海，讓人觸不到底，他問：“醒了？” 　
                        </p>
                        <p>寧也抿了抿唇，縮在被窩裡的手指忍不住蜷縮起來，輕聲的“嗯”了一聲，聲音細軟，顯得很乖。
                        </p>
                        <p>讓人和昨晚拿著小尖椒拚酒的那個小女孩，一點也聯係不到一塊去，道：“謝謝小叔，昨晚麻煩小叔了。”
                        </p>
                        <p>高大的影子覆蓋在寧也身上。
                        </p>
                        <p>寧也有些緊張起來。
                        </p>
                        <p>傅蘊庭伸出手指鉗製住了她的下顎，迫使她抬起頭來。
                        </p>
                        <p>
                            寧也對上了他有些深的眸子。
                        </p>
                        <p>
                            他拇指的指腹摁在寧也有些腫的嘴唇上，從一邊唇角用力摩擦到另一邊唇角。 　
                        </p>
                        <p>
                            寧也屏住了呼吸。 　　
                        </p>
                        <p>她不知道為什麼，心慌的叫了一聲：“小叔。” 　　</p>
                        <p>傅蘊庭鉗製著她下顎的手指沒有收回來，反而捏得更深，更沉：“你知不知道你昨晚差點死在這裡？”</p>
                        <p>傅蘊庭是什麼時候離開的，寧也不知道，隻覺得被他的手指鉗製著的時候，有一種缺氧的感覺。</p>
                        <p>寧也出院的時候，已經是三天以後。</p>
                        <p>公交車站離附加宅院有點遠，寧也走了很久，才看到宅院外面的保安亭。</p> <p>從保安亭進去，繞過九曲通幽的回廊，到達傅家别墅的大廳。</p>
                        <p>寧也踟躕了很久，才抬起腳步，剛要進去。</p>
                        <p>張媽幾步朝著她走過來，焦急的道：“你這兩天去了哪裡？打你電話一直打不通，怎麼這個點回來？”</p>
                        <p>寧也說：“我在外面有點事。”</p>
                        <p>張媽話說得很體面，道：“大少爺和小姐回來了，傅先生讓你如果回來，就先别進去了。”</p>
                        <p>她說的大少爺和小姐，就是寧也同父異母的哥哥和妹妹。</p>
                        <p>寧也愣了一下，沒想到傅稷和傅悅已經回了家。</p>
                        <p>她明白張媽的意思，他們才是和和睦睦的一家人，而她這個私生子，最好還是躲躲，别鬨得大家都不開心。</p>
                        <p>只是這話由自己的親生父親說出來，還是讓她有些難受。</p>
                        <p>寧也說：“我知道了。”</p>
                        <p>寧也說：“這幾天我同學過生日，讓我去她家借住一段時間。”</p>
                        <p>寧也收拾東西出了門，才發現已經是深夜了。</p>
                        <p>她在了公交車站的站牌那兒。等了半個小時，也冇等來車，剛準備站起身，一輛車子從裡麵開了出來。</p>
                        <p>寧也覺得車子莫名有些熟悉，還冇想出來怎麼回事，那輛車已經停在了她麵前。</p>
                        <p>車窗被降下來，寧也看清了車裡人的臉。</p>
                        <p>車內燈光昏暗，映得男人的側臉鋒利，眼瞳邃黑沉靜，寧也站在原地冇動，心弦緊繃起來。</p>
                        <p>“小叔。”</p>
                        <p>傅蘊庭透過半開的車窗往外看，他手指尖夾著一根煙，半明半暗。</p>
                        <p>落在寧也身上的目光，依舊沉靜得像是帶著力度。</p>
                        <p>“這麼晚，去哪裡？”</p>
                        <p>“去同學家裡。”</p>
                        <p>“寧也。”</p>
                        <p>傅蘊庭聲音沉了沉：“說實話。”</p>
                        <p>寧也周圍全被傅蘊庭的氣息包裹，讓她覺得很逼仄，壓迫。</p>
                        <p>“我說的是實話。”</p>
                        <p>“這麼晚去干什麼？”</p>
                        <p>寧也站著不吭聲了。</p>
                        <p>傅蘊庭手指上還夾著煙，他彈了彈煙灰，定定看了寧也一眼：“你去哪個同學家，我送你。”</p>
                        <p>“我打的車已經來了。”</p>
                        <p>“這條路上。”傅蘊庭的語調都冇變，依舊平靜沉穩，但卻是不容拒絕的強勢，猶如落在她身上的目光：“這麼晚打不到車。”</p>
                        <p>寧也捏緊了手上的背包。</p>
                        <p>傅蘊庭說：“上車。”</p>
                        <p>說完轉身繞過車尾，朝著駕駛座那邊走，拉開車門上了車。</p>
                        <p>寧也一手握著手機，一手捏著半挎在肩膀上的背包，在原地站定了一會兒，那輛蟄伏著的黑色獵豹依舊穩穩的停在那裡。</p>
                        <p>寧也最後還是上了車。</p>
                        <p>傅蘊庭看了她一眼，說：“把東西放後麵座椅上。”</p>
                        <p>傅蘊庭冇問她去哪兒。</p>
                        <p>她隻好開了口，聲音還是軟軟的，顯得很文靜：“小叔，我真的去我同學家，你把我放在曙光路就可以。”</p>
                        <p>傅蘊庭冇理她，啟動了車子。</p>
                        <p>車內很安靜，傅蘊庭顯得很沉默，但並不是不想說話的那種沉默。反而像是在思考醞釀著什麼。</p>
                        <p>傅蘊庭一隻手把著方向盤，一隻手伸出窗外，終於在一個十字路口，在一片窒息的沉默中，他抽了一口煙，突然道：“那天晚上我喝醉了……”</p>
                    </section>
                </section>
            </div>
        </div>
        <div class="downloadCon" ref="import" >
            <div>篇幅有限,下載<span class="name">「嗨文小說」</span>APP</div>
<!--            <div>搜索數字 <span id="num" ref="num" class="num" :data-clipboard-text="`haiwen_${copyCon}`" @click="copy()"> {{copyCon}} </span>繼續閱讀...</div>-->
            <div>免費閱讀更多精彩內容...</div>
        </div>
        <div class="clickImage">
            <img src="../../assets/extension/tip.gif"/>
        </div>
        <div class="center">
            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downApp()" href="javascript:void(0);"><img src="../../assets/extension/btn.png"/></a>
        </div>
    </div>
</template>

<script>
    import "utils/lib/rem";
    import Clipboard from 'clipboard'
    /*Facebook Pixel Code*/
    // !function(f,b,e,v,n,t,s)
    // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    //     n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    //     if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    //     n.queue=[];t=b.createElement(e);t.async=!0;
    //     t.src=v;s=b.getElementsByTagName(e)[0];
    //     s.parentNode.insertBefore(t,s)}(window, document,'script',
    //     'https://connect.facebook.net/en_US/fbevents.js');
    // fbq('init', '604117387548801');
    // fbq('track', 'PageView');
    import { extensionDetail } from "apiurl/extension";
    export default {
        name: "",
        data () {
            return {
                copyCon: '67',
                bookName: '明知故犯',
            }
        },
        mounted () {
            if (this.$route.query.num) {
                this.copyCon = this.$route.query.num
                this.bookName = this.$route.query.name
            }
            this.getDetail(this.bookName, 'load')
        },
        methods: {
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downApp() {
                this.copy()
                // fbq('track', 'Purchase', {currency: "USD", value: 0.01});
                let ua = navigator.userAgent.toLowerCase();
                //Android终端
                let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
          　     //Ios终端
                let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
                if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
                    window.location.href = 'https://apps.apple.com/cn/app/%E5%97%A8%E6%96%87%E5%B0%8F%E8%AA%AA/id1485535288'
                    this.getDetail(this.bookName, 'click')
                } else if (/(Android)/i.test(navigator.userAgent)) {
                    //Android终端
                    this.getDetail(this.bookName, 'click')
                    window.location.href = 'https://play.google.com/store/apps/details?id=com.haiwen.reader'
                }
            },
        },
    }
</script>
<!--<noscript><img height="1" width="1" style="display:none"-->
<!--               src="https://www.facebook.com/tr?id=604117387548801&ev=PageView&noscript=1"-->
<!--/></noscript>-->
<!-- End Facebook Pixel Code -->
<style scoped lang="scss">
    @import "../../styles/type8";
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    .page{
        display: inline-block;
        width: 100%;
        background: #fff;
        height: 100vh;
    }
    .page-content{
        max-width: 700px;
        margin:auto;
        p{
            line-height: 1.6;
            margin-bottom: 20px;
            margin: 0 0 10px;
        }
    }
    .rand_pic{
        width: 100%;
    }
    .downloadCon{
        width: 100%;
        text-align: center;
        color: #1f80e3;
        font-size:1.25rem;
        font-weight: bold;
        margin-top: 30px;
        .name{
            color: #fe3f72;
            font-size: 1.7rem;
        }
        .num{
            color:  #e31f44;
            font-size: 1.65rem;
        }
    }
    .clickImage{
        margin-top: -10px;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .center{
        display: inline-block;
        width: 100%;
        margin: auto;
        margin-bottom: 20px;
        .download-btn {
            display: block;
            width: 100%;
            text-align: center;
            img{
                width: 172px;
                height: 49px;
            }
        }
    }
</style>
